import { render, staticRenderFns } from "./CorePicture.vue?vue&type=template&id=dbcbc81c&scoped=true&"
import script from "./CorePicture.vue?vue&type=script&lang=ts&"
export * from "./CorePicture.vue?vue&type=script&lang=ts&"
import style0 from "./CorePicture.vue?vue&type=style&index=0&id=dbcbc81c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcbc81c",
  null
  
)

export default component.exports